
// import Notice from "~/components/home/notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      imageList: [
        {
          id: 1,
          src:  require(`@/static/images/applicationIntroduction/b_intro_2.png`),
        }
      ],
      imageList2: [
        {
          id: 2,
          src: require(`@/static/images/applicationIntroduction/b_intro_1_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
        }
      ],
      b_intro_2: require(`@/static/images/applicationIntroduction/b_intro_2_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_3: require(`@/static/images/applicationIntroduction/b_intro_3_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_4: require(`@/static/images/applicationIntroduction/b_intro_4_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
      b_intro_5: require(`@/static/images/applicationIntroduction/b_intro_5_${this.$i18n.locale == 'en' ? 'en' : 'cn'}.png`),
    }
  },
  computed: {
    contentList1() {
      let data = this.$t('Applicationintroduction.Bend.contentList1');
      return data;
    },
    contentList2() {
      let data = this.$t('Applicationintroduction.Bend.contentList2');
      return data;
    },
    contentList3() {
      let data = this.$t('Applicationintroduction.Bend.contentList3');
      return data;
    },
    contentList4() {
      let data = this.$t('Applicationintroduction.Bend.contentList4');
      return data;
    },
    contentList5() {
      let data = this.$t('Applicationintroduction.Bend.contentList5');
      return data;
    },
    contentList6() {
      let data = this.$t('Applicationintroduction.Bend.contentList6');
      return data;
    }
  },
}
